import * as z from 'zod'

export const bankUsersReportFilterParamsSchema = z.object({
  active: z.boolean().optional().nullable().default(true),
  page: z.number().int().positive().default(1),
  size: z.number().int().positive().default(10),
  sortBy: z.string().optional().nullable().default(''),
  sortDesc: z.boolean().optional().nullable().default(false)
})

export type BankUsersReportFilterParams = z.infer<typeof bankUsersReportFilterParamsSchema>
